import Button from 'components/Button'
import TwitterIcon from 'components/Icons/Twitter'
import { makeRedirectTokenForUser } from 'data/users/client'
import { RedirectTokenCommentData } from 'data/users/types'
import { useParentUrl } from 'hooks/useParentUrlRecording'
import { useState } from 'react'
import styles from './LoginCommenter.module.css'

type Props = {
  commentData?: RedirectTokenCommentData,
}

const LoginCommenter = ({ commentData }: Props) => {
  const [isRedirecting, setIsRedirecting] = useState(false)
  const parentUrlString = useParentUrl()
  console.log({ parentUrlString })
  const handleLogin = async () => {
    setIsRedirecting(true)
    const redirectToken = await makeRedirectTokenForUser(parentUrlString, commentData)
    console.log({ redirectToken })
    const parentUrl = new URL(parentUrlString)
    const origin = parentUrl.host
    const redirectUrl = `https://${window.location.host}/commenting/login/${redirectToken}`
    window?.parent?.postMessage({
      blotter: {
        type: 'loginRedirect',
        redirectUrl,
      }
    }, `https://${origin}`)
  }
  return <div className={styles.loginCommenter}>
    <h2 className={styles.explanationHeadline}>
      Log In with Twitter to Post Your Comment
    </h2>
    <div className={styles.loginSection}>
      <p className={styles.body}>Next, you’ll be asked for account permissions on Twitter. These will be used only for service functionality, e.g., posting your comment.</p>
      <div className={styles.loginButton}>
        <Button
          variant='small'
          icon={<TwitterIcon width={26} height={26} fill='#fff' />}
          onClick={() => { handleLogin() }}
          isDisabled={isRedirecting}
        >
          Comment With Twitter
        </Button>
      </div>
    </div>
  </div>
}

export default LoginCommenter
